import { render, staticRenderFns } from "./AddAdress.vue?vue&type=template&id=3c6a48ee&scoped=true"
import script from "./AddAdress.vue?vue&type=script&lang=js"
export * from "./AddAdress.vue?vue&type=script&lang=js"
import style0 from "./AddAdress.vue?vue&type=style&index=0&id=3c6a48ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6a48ee",
  null
  
)

export default component.exports